import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import { BookingProvider } from "./contexts/BookingContext";
import { AuthProvider } from "./contexts/AuthContext";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import AfroHairPage from "./pages/AfroHairPage";
import SpaWellnessPage from "./pages/SpaWellnessPage";
import GalleryPage from "./pages/GalleryPage";
import StorePage from "./pages/StorePage";
import TrainingPage from "./pages/TrainingPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import ConsultationPage from "./pages/ConsultationPage";
import AdminPage from "./pages/AdminPage";
import AdminCMSPage from "./pages/AdminCMSPage";
import AdminCoursesPage from "./pages/AdminCoursesPage";
import PromotionsPage from "./pages/PromotionsPage";
import LoginPage from "./pages/LoginPage";
import AuthCallback from "./pages/AuthCallback";
import MyCoursesPage from "./pages/MyCoursesPage";
import CourseViewerPage from "./pages/CourseViewerPage";
import CertificatePage from "./pages/CertificatePage";
import AdminCourseContentPage from "./pages/AdminCourseContentPage";
import { Toaster } from "./components/ui/sonner";

// Router component that handles OAuth callback detection
function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment (not query params) for session_id - must be synchronous
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<Layout><HomePage /></Layout>} />
      <Route path="/services" element={<Layout><ServicesPage /></Layout>} />
      <Route path="/afro-hair" element={<Layout><AfroHairPage /></Layout>} />
      <Route path="/spa-wellness" element={<Layout><SpaWellnessPage /></Layout>} />
      <Route path="/gallery" element={<Layout><GalleryPage /></Layout>} />
      <Route path="/store" element={<Layout><StorePage /></Layout>} />
      <Route path="/training" element={<Layout><TrainingPage /></Layout>} />
      <Route path="/about" element={<Layout><AboutPage /></Layout>} />
      <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
      <Route path="/consultation" element={<Layout><ConsultationPage /></Layout>} />
      <Route path="/admin" element={<Layout><AdminPage /></Layout>} />
      <Route path="/admin/cms" element={<Layout><AdminCMSPage /></Layout>} />
      <Route path="/admin/courses" element={<Layout><AdminCoursesPage /></Layout>} />
      <Route path="/promotions" element={<Layout><PromotionsPage /></Layout>} />
      {/* Auth & E-learning Routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/my-courses" element={<MyCoursesPage />} />
      <Route path="/course/:courseId" element={<CourseViewerPage />} />
      <Route path="/certificate/:certificateId" element={<CertificatePage />} />
      
      {/* Admin Course Content */}
      <Route path="/admin/course-content" element={<AdminCourseContentPage />} />
    </Routes>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BookingProvider>
          <div className="App">
            <BrowserRouter>
              <AppRouter />
            </BrowserRouter>
            <Toaster />
          </div>
        </BookingProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
